import React, { useState, useEffect, useContext } from "react";
import { makeStyles, withStyles } from "@mui/styles";
import { Link, BrowserRouter as Router, Redirect } from "react-router-dom";
import axios from "axios";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import {
  ActionPlansProvider,
  ActionPlansContext,
} from "context/ActionPlansContext";

import { ActionProvider, ActionContext } from "context/ActionContext";
import UserService from "services/UserService";
import { getAction } from "services/ConfigServices";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import TabHeader from "components/Ui/Header/TabHeader";
import CustomTabs2 from "components/CustomTabs2/CustomTabs2";
import Analysis from "./Analysis/Analysis";
import AboutTabs from "./About/AboutTabs";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import CustomConfirmationDialog from "components/CustomDialog/CustomConfirmationDialog";
import {
  Navigate, useLocation
} from "react-router-dom";


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "0 0 5px 5px",
    boxShadow: "0 1px 4px 0 rgb(0 0 0 / 14%)",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));

export default function SelectedActions(props) {
  const { state } = useLocation();
  if (!state) {
    return (
      <Navigate
        push
        to={{
          pathname: "/admin/actionplans",
        }}
      />
    )
  }
  else {
    const { planActionId, planActionName, actionId, actionName, groupParent, actionPlansParameters } = state;
    return (
      <ActionPlansProvider>
        <ActionProvider>
          <SelectedActionsChild
            {...{
              planActionId,
              planActionName,
              actionId,
              actionName,
              groupParent,
              actionPlansParameters,
            }}
          />
        </ActionProvider>
      </ActionPlansProvider>
    );
  }
}

function SelectedActionsChild({
  planActionId,
  planActionName,
  actionId,
  actionName,
  groupParent,
  actionPlansParameters,
}) {
  const advancedSearchContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, setOutofcontextclic, setChartIdGroup, selectedNodesInfo, setSelectedNodesInfo } = advancedSearchContext;
  const classes = useStyles();
  const appContext = useContext(ActionContext);
  const { action, setAction } = appContext;
  const actionPlansContext = useContext(ActionPlansContext);
  const { setActionPlans } = actionPlansContext;

  const { parameters } = action;
  const [prevIdGroup, setPrevIdGroup] = useState(["0"]);
  const [prevNodesInfo, setPrevNodesInfo] = useState("");
  const [openExitConfirmation, setOpenExitConfirmation] = useState(false);
  const [redirState, setRedirState] = useState(false);

  const [isLoading, setIsLoading] = useState(true);

  let redirecting = redirState && (
    <Navigate
      push
      to={{
        pathname: "/admin/actionplans",
      }}
    />
  );

  useEffect(() => {
    axios
      .get(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((response) => {
        setAction(response.data || []);
        setIsLoading(false);
      });
  }, []);

  useEffect(() => {
    setActionPlans(actionPlansParameters);
  }, [actionPlansParameters]);

  useEffect(() => {
    if (chartIdGroup && chartIdGroup[0] !== "0") {
      if (prevIdGroup && prevIdGroup[0] === chartIdGroup[0]) {
        return;
      }
      else if (prevIdGroup[0] !== "0") {
        setOpenExitConfirmation(true,);
      }
      else {
        setPrevIdGroup([...chartIdGroup]);
        setPrevNodesInfo(selectedNodesInfo);
      }
    }
    else {
      setPrevIdGroup([...chartIdGroup]);
      setPrevNodesInfo(selectedNodesInfo);
    }
  }, [chartIdGroup]);

  const handleClose = (e) => {
    setOutofcontextclic(prevIdGroup);
    setChartIdGroup(prevIdGroup);
    setSelectedNodesInfo(prevNodesInfo);
    setOpenExitConfirmation(false);
  };

  const handleExit = (e) => {
    setOpenExitConfirmation(false);
    setRedirState(true);
  };

  if (actionId === "") {
    return (
      <Navigate
        push
        to={{
          pathname: "/admin/actionplans",
        }}
      />
    );
  }

  const url = getAction(actionId);

  const data2 = [
    {
      value: "0",
      label: "À propos",
      component: (
        <div
          style={{
            // boxShadow: "0 1px 4px 0 grey",
            // borderRadius: "6px",
            //padding: "0.3rem 0.6rem",
            backgroundColor: "white",
            marginTop: "0.5rem",
          }}
        >
          <AboutTabs
            {...parameters}
            //scenarios={action.scenarios}
            planActionId={planActionId}
            groupParent={groupParent}
          />
        </div>
      ),
    },
    // { value: "1", label: "Analyses", component: <Analysis /> },
  ];

  return (
    <>
      <GridContainer>
        <GridItem xs={12}>
          <TabHeader>
            <>
              <Link to="/admin/actionplans">
                <div
                  style={{
                    fontSize: "13px",
                    color: "#fff",
                    opacity: "0.8",
                    marginRight: "0.3rem",
                  }}
                >
                  PLAN D'ACTIONS
                </div>
              </Link>
              <Link
                to={{
                  pathname: "/admin/actionplans/selectedplanaction/",
                  state: { planActionId, planActionName },
                }}
              >
                <div
                  style={{
                    fontSize: "13px",
                    color: "#fff",
                    opacity: "0.8",
                  }}
                >
                  / {planActionName}
                </div>
              </Link>
              <div
                style={{
                  marginLeft: "5px",
                  marginTop: "0px",
                  marginBottom: "5px",
                  fontSize: "15px",
                  fontWeight: "bold",
                }}
              >
                / {actionName}
              </div>
            </>
          </TabHeader>
        </GridItem>
        <GridItem xs={12}>
          {!isLoading && (
            <div className={classes.demo2}>
              <CustomTabs2 data={data2} />
            </div>
          )}
        </GridItem>
      </GridContainer>
      <CustomConfirmationDialog
        open={openExitConfirmation}
        handleClose={handleClose}
        handleExit={handleExit}
        dialogContent={"Etes vous sur de vouloir sortir du plan d'action?"}
        id={"draggable-dialog-title"}
      />
      {redirecting}
    </>
  );
}
